import { render, staticRenderFns } from "./NamesComparisonAlerts.vue?vue&type=template&id=076d0c9a&"
import script from "./NamesComparisonAlerts.vue?vue&type=script&lang=js&"
export * from "./NamesComparisonAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports